import axios, { AxiosInstance } from 'axios';
import * as API from '../../../constants/API';
import { YogaRecord, YogaMenu } from '../../../constants/Records';

export class YogaApiClient {
  private api: AxiosInstance;

  static async ClientFactory(): Promise<YogaApiClient> {
    return new YogaApiClient();
  }

  constructor() {
    const apiKey = process.env.REACT_APP_YOGA_API_KEY || '';

    this.api = axios.create({
      baseURL: API.yogaApiRoot,
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
    });
  }

  // メニュー一覧取得
  async getMenus(): Promise<YogaMenu[]> {
    const res = await this.api.get('/yoga/menu');
    return res.data;
  }

  // レコード件数取得（効率的なカウント用）
  async getRecordCount(uniqueId: string): Promise<number> {
    const res = await this.api.get(`/yoga/users/${uniqueId}/records`);
    // APIレスポンスは { total: number, records: YogaRecord[] } 形式
    return res.data.total || 0;
  }

  // レコード一覧取得
  async getRecords(uniqueId: string): Promise<YogaRecord[]> {
    const res = await this.api.get(`/yoga/users/${uniqueId}/records`);
    // APIレスポンスは { total: number, records: YogaRecord[] } 形式
    return res.data.records || [];
  }

  // 特定レコード取得
  async getRecord(uniqueId: string, recordTime: string): Promise<YogaRecord> {
    const encodedTime = encodeURIComponent(recordTime);
    const res = await this.api.get(`/yoga/users/${uniqueId}/records/${encodedTime}`);
    return res.data;
  }

  // 最新レコード取得
  async getLatestRecord(uniqueId: string): Promise<YogaRecord> {
    const res = await this.api.get(`/yoga/users/${uniqueId}/records/latest`);
    return res.data;
  }

  // 期間指定取得
  async getRecordsByDateRange(uniqueId: string, from: string, to: string): Promise<YogaRecord[]> {
    const res = await this.api.get(`/yoga/users/${uniqueId}/records/from/${from}/to/${to}`);
    // APIレスポンスは { total: number, records: YogaRecord[] } 形式
    return res.data.records || [];
  }

  // レコード作成
  async createRecord(data: Partial<YogaRecord>): Promise<YogaRecord> {
    const res = await this.api.post('/yoga/record', data);
    return res.data;
  }

  // レコード更新
  async updateRecord(uniqueId: string, recordTime: string, data: Partial<YogaRecord>): Promise<YogaRecord> {
    const encodedTime = encodeURIComponent(recordTime);
    const res = await this.api.put(`/yoga/users/${uniqueId}/records/${encodedTime}`, data);
    return res.data;
  }

  // レコード削除
  async deleteRecord(uniqueId: string, recordTime: string): Promise<void> {
    const encodedTime = encodeURIComponent(recordTime);
    await this.api.delete(`/yoga/users/${uniqueId}/records/${encodedTime}`);
  }
}
